module.exports = __webpack_public_path__ + "img/anji.eff874c6.png";